import React from "react";
import { RouterProvider } from "react-router-dom";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AlertProvider } from "contexts/AlertContext";
import { ApolloContext } from "contexts/ApolloContext";
import { DataProvider } from "contexts/DataContext";
import { GQLProvider } from "contexts/GQLContext";
import { TAuthProvider } from "contexts/TAuthContext";
import { ThemeProvider } from "contexts/ThemeContext";
import { router } from "data/routes";
import ruLocale from "date-fns/locale/ru";

const App = () => {
  return <AppWithMemo />;
};

const AppWithMemo = React.memo((AppWithMemo) => {
  return (
    <LocalizationProvider adapterLocale={ruLocale} dateAdapter={AdapterDateFns}>
      <AlertProvider>
        <ApolloContext>
          <DataProvider>
            <TAuthProvider>
              <ThemeProvider>
                <GQLProvider>
                  {/* <MainPage /> */}
                  <RouterProvider router={router} />
                  {/* <Button onClick={colorMode.toggleColorMode}>Поменять тему</Button> */}
                </GQLProvider>
              </ThemeProvider>
            </TAuthProvider>
          </DataProvider>
        </ApolloContext>
      </AlertProvider>
    </LocalizationProvider>
  );
});

export default App;
